import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  id: string;
};

export const useArticleCategoryDelete = () => {
  const [ArticleCategoryDeleteLoading, setArticleCategoryDeleteLoading] =
    useState(false);

  const ArticleCategoryDeleteReq = useCallback(async (params: TParams) => {
    setArticleCategoryDeleteLoading(true);
    const res = await request({
      path: "article-category/delete",
      method: "POST",
      body: JSON.stringify(params),
    });
    setArticleCategoryDeleteLoading(false);
    return res?.data;
  }, []);

  return { ArticleCategoryDeleteLoading, ArticleCategoryDeleteReq };
};
